import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { api } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

let instance: AxiosInstance;

const axiosInstance = async () => {
  instance = axios.create({
    baseURL: api + "/api/v1/stock-position",
  });
  // Attach 403 refresh-and-retry interceptor
  attachRefreshInterceptor(instance);

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};

axiosInstance();

// Uploads the company-provided stock/alternate-item-code file. The backend parser
// (per-company format) resolves and persists rows; the frontend only sends the raw
// file + company_code. axios sets the multipart boundary from the FormData body.
export const uploadStockPosition = async (file: File, company_code: number | string): Promise<AxiosResponse> => {
  const form = new FormData();
  form.append("file", file);
  form.append("company_code", String(company_code));
  return instance.post("/upload", form);
};

// Lists the existing stock position rows (company_item_plant_stock) for a company.
// Read-only; powers the "View stock position" modal. Optional search filters
// item_code / plant_code / division_shortcode server-side.
export const getCompanyItemPlantStock = async (company_code: number | string, search?: string): Promise<AxiosResponse> => {
  const params = new URLSearchParams({ company_code: String(company_code) });
  if (search?.trim()) params.append("search", search.trim());
  return instance.get(`/list?${params.toString()}`);
};
